import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';

export interface FilterDocumentsReglementaire {
    page?: number;
    sort?: string;
    typeDocumentsReglementaireIds?: number[];
    typeDocumentsReglementaireCodes?: string[];
    chantierIds?: number[];
    adresseProjetId?: number[];
    groupeId?: number[];
    equipementId?: number[];
    sousGroupeId?: number[];
    phaseId?: number[];
    dateDebut?: string;
    dateFin?: string;
    isForModal?: boolean;
    size?: number;
    nomZip?: string;
    interventionId?: number;
    isBim?: boolean;
}

export interface DocumentReglementaireToDownload {
    uniqueDocumentIds?: string[];
    chantierIds?: number[];
    nomZip?: string;
    nomDocument?: string;
    extension?: string;
    isBim?: boolean;
}

class DocumentReglementaireService {
    public async getDocumentReglementaire(params: FilterDocumentsReglementaire): Promise<any> {
        return http.get(Routes.DocumentReglementaire.GetDocumentReglementaire(), { params });
    }
    public async getDocumentReglementairePDF(params: DocumentReglementaireToDownload): Promise<any> {
        return http.get(Routes.DocumentReglementaire.GetDocumentReglementairePDF(), {
            params,
            responseType: 'arraybuffer',
        });
    }
    public async getAllDocumentReglementairePDF(params: FilterDocumentsReglementaire): Promise<any> {
        return http.get(Routes.DocumentReglementaire.GetAllDocumentReglementairePDF(), {
            params,
            responseType: 'arraybuffer',
        });
    }
    public async getTypesDocumentReglementaire(): Promise<any> {
        return http.get(Routes.DocumentReglementaire.GetTypesDocumentReglementaire());
    }
    public async getAnalysesDeRisques(params: FilterDocumentsReglementaire): Promise<any> {
        return http.get(Routes.AnalyseDeRisqueRoutes.RecupererAnalyseDeRisquePublies(), { params });
    }
    public async getPrisesEnCharge(params: FilterDocumentsReglementaire): Promise<any> {
        return http.get(Routes.PriseEnChargeRoutes.RecupererPrisesEnCharge(), { params });
    }
    public async getPdfPriseEnCharge(idDocExterne: string | number, idVersionExterne: string | number): Promise<any> {
        return http.get(Routes.PriseEnChargeRoutes.RecupererPdfPriseEnCharge(idDocExterne, idVersionExterne),  { responseType: 'arraybuffer' });
    }
    public async getAdrPDF(params: DocumentReglementaireToDownload): Promise<any> {
        return http.get(Routes.DocumentReglementaire.GetAdrPDF(), { params, responseType: 'arraybuffer' });
    }
    public async getAllAdrPDF(params: FilterDocumentsReglementaire): Promise<any> {
        return http.get(Routes.DocumentReglementaire.GetAllAdrPDF(), { params, responseType: 'arraybuffer' });
    }
}

export default new DocumentReglementaireService();
